import { render, staticRenderFns } from "./taskParams.vue?vue&type=template&id=4b40ed94&scoped=true"
import script from "./taskParams.vue?vue&type=script&lang=js"
export * from "./taskParams.vue?vue&type=script&lang=js"
import style0 from "./taskParams.vue?vue&type=style&index=0&id=4b40ed94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b40ed94",
  null
  
)

export default component.exports